export default __webpack_public_path__ + "static/media/fi.ace59fb9.svg";